import { render, staticRenderFns } from "./brand-button.vue?vue&type=template&id=463bd70d&scoped=true&"
import script from "./brand-button.vue?vue&type=script&lang=js&"
export * from "./brand-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463bd70d",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CButton: require('@chakra-ui/vue').CButton})
